// Florium public demo studio — demo.florium.live/demo, API demo.florium.live/api.
// Everything here is public: the demo logins are printed on the demo banner and the
// Stripe key is a TEST publishable key (set REACT_APP_DEMO_STRIPE_PUBLISHABLE_KEY at build).
const demo = {
  studioId: 'demo',
  studioName: 'Florium Demo Studio',
  apiBaseUrl: process.env.REACT_APP_DEMO_API_BASE_URL || 'https://demo.florium.live/api',
  siteUrl: 'https://florium.live',
  stripePublishableKey: process.env.REACT_APP_DEMO_STRIPE_PUBLISHABLE_KEY,
  zoomHostLink: '',
  flags: { demoBanner: true, siteNav: true },
  demoLogins: [
    { role: 'Owner',   email: 'owner@example.com',   password: 'florium2026' },
    { role: 'Teacher', email: 'teacher@example.com', password: 'florium2026' },
  ],
  theme: {
    '--primary-hue':           '140',
    '--grey-hue':              '140',
    '--color-primary':         'hsl(140, 30%, 92%)',
    '--color-primary-variant': 'hsl(140, 45%, 32%)',
    '--color-secondary':       '#c9a84c',
    '--color-tertiary':        '#1e5c3a',
    '--color-hybrid':          '#6a6454',
    '--color-grey-100':        'hsl(140, 20%, 96%)',
    '--color-grey-200':        'hsl(140, 12%, 78%)',
    '--color-grey-300':        'hsl(140, 10%, 62%)',
    '--color-grey-400':        'hsl(140, 8%, 38%)',
    '--color-grey-500':        'hsl(140, 20%, 24%)',
    '--color-grey-600':        'hsl(140, 25%, 14%)',
  },
  venues: [
    { id: 'venue_001',    name: 'Main Studio', address: '100 Garden Way, Springfield' },
    { id: 'venue_002',    name: 'Garden Room', address: '100 Garden Way, Springfield' },
    { id: 'venue_online', name: 'Online',      address: null },
  ],
};

export default demo;
